module.exports = __webpack_public_path__ + "img/icon-profile_feedback.eafcb119.png";